import { serviceApi } from '~/features';
import { DeleteResponse } from '~/types/cnpj/delete.response';

export async function deleteCnjpsListProducts(campanhaId: string) {
  return serviceApi.delete<DeleteResponse>(
    `/CampanhaProdutosPatrocinados/DeleteCNPJ?campanhaId=${campanhaId}`
  );
}
